import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const getPropertyCategories = async () => {
  try {
    const PropertyDynamicFieldsDoc = await doc(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "dynamicFields",
      "property"
    );
    const snap = await getDoc(PropertyDynamicFieldsDoc);
    return snap.data().propertyCategories;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default getPropertyCategories;
